// extracted by mini-css-extract-plugin
module.exports = {"carouselWrapper":"carousel-wrapper_carouselWrapper__LE4Ku","showCarousel":"carousel-wrapper_showCarousel__G6l0P"};